import isNil from "lodash/isNil";

import { ScheduleAnalyticsEvent } from "@/constants/analytics/Scheduling";
import {
  ScheduleEventDetailsSubDeepLinks,
  ScheduleTabSubDeepLinks,
} from "@/constants/Schedule";
import useScheduleEventDetailsSubDeepLink from "@/hooks/deepLinking/subDeepLinks/useScheduleEventDetailsSubDeepLink";
import useEncodedSearchParams from "@/hooks/useEncodedSearchParams";
import { useGetAppointmentQuery } from "@/store/api/schedule/schedule";

type AppointmentSubDeepLinkTarget =
  | ScheduleTabSubDeepLinks.Appointment
  | ScheduleTabSubDeepLinks.EditAppointment;

const useAppointmentSubDeepLink = (
  targetValue: AppointmentSubDeepLinkTarget,
) => {
  const { appointmentExternalId } = useEncodedSearchParams<{
    appointmentExternalId?: string;
  }>();

  const {
    data: appointment,
    error,
    isFetching,
  } = useGetAppointmentQuery(
    appointmentExternalId ?? "",
    // eslint-disable-next-line @typescript-eslint/naming-convention -- RTK Query option name
    { skip: isNil(appointmentExternalId) },
  );

  const isEditAppointment =
    targetValue === ScheduleTabSubDeepLinks.EditAppointment;

  useScheduleEventDetailsSubDeepLink({
    analyticsEvent: isEditAppointment
      ? ScheduleAnalyticsEvent.EditAppointmentOpenedFromDeepLink
      : ScheduleAnalyticsEvent.AppointmentOpenedFromDeepLink,
    appointmentMetaData: appointment,
    data: appointment,
    error,
    errorLabel: "appointment",
    isFetching,
    isGroupClassEvent: false,
    modalTitle: "Appointment details",
    paramKey: "appointmentExternalId",
    paramValue: appointmentExternalId,
    // edit-appointment opens the details modal then auto-opens the edit bottom sheet
    subtarget: isEditAppointment
      ? ScheduleEventDetailsSubDeepLinks.Edit
      : undefined,
    targetValue,
  });
};

export default useAppointmentSubDeepLink;
